import script from "./ContactUsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsSection.vue?vue&type=script&setup=true&lang=js"

import "./ContactUsSection.vue?vue&type=style&index=0&id=5fa8f4fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa8f4fe"]])

export default __exports__